var rellax = new Rellax('.rellax');

$(document).ready(function () {


    const leftHen = $(".img_h2p_3_lh");
    const rightHen = $(".img_h2p_3_rh");
    const img_h2p_4_bc = $(".img_h2p_4_bc");
    const img_h2p_4_gc = $(".img_h2p_4_gc");
    const img_h2p_5_hen = $(".img_h2p_5_hen");
    const img_h2p_cock3_blueCock_right = $(".img_h2p_cock3_blueCock_right");
    const img_h2p_cock3_blueCock_left = $(".img_h2p_cock3_blueCock_left");
    const img_h2p_6_se = $(".img_h2p_6_se");
    const img_h2p_7_rat = $(".img_h2p_7_rat");
    const img_h2p_8_fox = $(".img_h2p_8_fox");
    const img_h2p_9_pig = $(".img_h2p_9_pig");



    var waypointh2p_1 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_1'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
            }
        },
        offset: '100%'
    });

    var waypointh2p_2 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_2'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
            }
        },
        offset: '70%'
    });

    var waypointh2p_3 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_3'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
                $(leftHen).removeClass("inLeft");
                $(rightHen).removeClass("inRight");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
                $(leftHen).addClass("inLeft");
                $(rightHen).addClass("inRight");
            }
        },
        offset: '70%'
    });

    var waypointh2p_4 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_4'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
                $(img_h2p_4_bc).removeClass("inLeft");
                $(img_h2p_4_gc).removeClass("inRight");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
                $(img_h2p_4_bc).addClass("inLeft");
                $(img_h2p_4_gc).addClass("inRight");
            }
        },
        offset: '70%'
    });

    var waypointh2p_5 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_5'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
                $(img_h2p_5_hen).removeClass("in_h2p_5");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
                $(img_h2p_5_hen).addClass("in_h2p_5");
            }
        },
        offset: '70%'
    });

    var waypointh2p_cock1 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_cock1'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
            }
        },
        offset: '70%'
    });

    var waypointh2p_cock2 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_cock2'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
            }
        },
        offset: '70%'
    });

    var waypointh2p_cock3 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_cock3'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
                $(img_h2p_cock3_blueCock_right).removeClass("inRight");
                $(img_h2p_cock3_blueCock_left).removeClass("inLeft");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
                $(img_h2p_cock3_blueCock_right).addClass("inRight");
                $(img_h2p_cock3_blueCock_left).addClass("inLeft");
            }
        },
        offset: '70%'
    });

    var waypointh2p_cock4 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_cock4'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
            }
        },
        offset: '70%'
    });

    var waypointh2p_6 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_6'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
                $(img_h2p_6_se).removeClass("inRight");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
                $(img_h2p_6_se).addClass("inRight");
            }
        },
        offset: '70%'
    });

    var waypointh2p_7 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_7'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
                $(img_h2p_7_rat).removeClass("inLeft");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
                $(img_h2p_7_rat).addClass("inLeft");
            }
        },
        offset: '70%'
    });

    var waypointh2p_8 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_8'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
                $(img_h2p_8_fox).removeClass("inRight");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
                $(img_h2p_8_fox).addClass("inRight");
            }
        },
        offset: '70%'
    });

    var waypointh2p_9 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_9'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
                $(img_h2p_9_pig).removeClass("inLeft");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
                $(img_h2p_9_pig).addClass("inLeft");
            }
        },
        offset: '70%'
    });

    var waypointh2p_10 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_10'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
            }
        },
        offset: '70%'
    });

    var waypointh2p_11 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_11'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
            }
        },
        offset: '70%'
    });

    var waypointh2p_12 = new Waypoint({
        element: document.getElementsByClassName('cck_h2p_12'),
        handler: function (direction) {
            if (direction === 'down') {
                $(this.element).addClass("fadedIn");
            } else if (direction === 'up') {
                $(this.element).removeClass("fadedIn");
            }
        },
        offset: '70%'
    });


    var footer = new Waypoint({
        element: document.getElementById('cck_footer'),
        handler: function (direction) {
            if (direction === 'down') {
                $("#cck-body").addClass("footered");
            } else if (direction === 'up') {
                $("#cck-body").removeClass("footered");
            }
        },
        offset: '100%'
    });


});

LottieInteractivity.create({
player:'#ffLottie',
mode:"scroll",
    actions: [
    {
        visibility:[0, 1.0],
        type: "seek",
        frames: [0, 123],
    },
    ]
});


(function () {

    var quotes = $(".quotes");
    var quoteIndex = -1;

    function showNextQuote() {
        ++quoteIndex;
        quotes.eq(quoteIndex % quotes.length)
            .fadeIn(1000)
            .delay(4000)
            .fadeOut(1000, showNextQuote);
    }

    showNextQuote();

})();
